import * as React from 'react'
import { useSnackbar, OptionsObject, SnackbarMessage, SnackbarKey } from 'notistack';
import { screenContext, IScreenContext } from '../../contexts/ScreenProvider'
import { IConfirmModalProps } from '../../components/global/Modal/ConfirmModal'

interface ReturnValues extends IScreenContext {
    enqueueSnackbar: (message: SnackbarMessage, options?: OptionsObject | undefined) => SnackbarKey,
}

const useScreen = (): ReturnValues => {
    const appContext: IScreenContext = React.useContext<any>(screenContext)
    const { isLoading, setIsLoading, confirmbox, slidePageStyle, setSlidePage, topEleRef } = appContext
    const { enqueueSnackbar } = useSnackbar()

    return { setIsLoading, isLoading, enqueueSnackbar, confirmbox, slidePageStyle, setSlidePage, topEleRef }
}

export default useScreen